export const DEADLINE = new Date('Oct 24, 2020 20:00:00').getTime();

export const FULL_DATE = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};
